import React from "react";
import {
  Box,
  Typography,
  IconButton,
  // Menu,
  // MenuItem,
  // Divider,
  Card,
  CardMedia,
  // ListItemIcon,
} from "@mui/material";
import {
  Folder,
  MoreVert,
  // OpenInNew,
  // FileDownload,
  // Create,
  // FileCopy,
  // Share,
  // Delete,
  // FolderOutlined,
  // AccountCircle,
} from "@mui/icons-material";
 
import { useTheme } from "../style/theme";
// import { useMediaQuery } from "@mui/material";
// import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// import amico from "../assets/Upgradehrimages/dummyfileimage.png";
// import SlideUpMenu from "./SlideUpMenu";
// import { Link, ArrowDropDown, Close } from "@mui/icons-material";
import { useUser } from '../hooks/Authorize';
import { getFileIconAndColor, useSortedItems } from "./utils";
// import ItemMorevertMenu from "./ItemMorevertMenu.jsx";
import NoResourcesAvailable from "./NoResourcesAvailable.jsx";



const TileFilesFolder = ({ title = 'Files', handleMoreVertMenuOpen, isRecentView, items, setClikkleItems, gridStyle = true, selectedSort, setSelectedSort, isDescending, setIsDescending, handleDoubleClickFilePreview, showTitle = true }) => {

  // const [currentMenuClickedItem, setCurrentMenuClickedItem] = useState({});
  // const [toggleSlideMenu, setToggleSlideMenu] = useState(false);
  const platformUser = JSON.parse(localStorage.getItem("user"));

  var sortedItems = useSortedItems(items, selectedSort, isDescending, platformUser._id)
  sortedItems = [...sortedItems]
    .filter(item => {
      // Check for uniqueness by _id AND (name + folderPath)
      const isUniqueById = items.findIndex(i => i._id === item._id) === items.indexOf(item);
      const isUniqueByNameAndPath = items.findIndex(i =>
        i.name === item.name &&
        i.folderPath === item.folderPath
      ) === items.indexOf(item);

      return isUniqueById && isUniqueByNameAndPath && item.type === "file";

    })

  const { mode } = useTheme();
  // const isMobile = useMediaQuery("(max-width:600px)");


  // const handleMoreVertMenuOpen = (event, item) => {
  //   setAnchorEl(event.currentTarget);
  //   // setAnchorElSubMenu(null);
  //   // setSubmenuOpen(false); // Close submenu on menu close

  //   setCurrentMenuClickedItem(item);
  //   console.log("Menu opened: ", item)
  // };









  // if (isMobile && gridStyle) {
  //   return (
  //     <Box
  //       display="grid"
  //       gap="1rem"
  //       width={"100%"}
  //       sx={{
  //         gridTemplateColumns: `repeat(auto-fit,${isMobile ? " minmax(7.5rem, 1fr))" : " minmax(15rem, 1fr))"
  //           }`,
  //       }}
  //     >
  //       {items.map((item, index) => (
  //         <Box
  //           onDoubleClick={() => console.log(item)}
  //           // onDoubleClick={() => handleDoubleClickFilePreview(item)}
  //           key={index}
  //           paddingBottom={"1rem"}
  //           display="flex"
  //           flexDirection="column"
  //           alignItems="center"
  //           justifyContent={"space-between"}
  //           gap={"1rem"}
  //           sx={{
  //             border: `2px solid ${mode === "light" ? "#e5e7eb" : "transparent"
  //               }`,
  //             borderRadius: "0.5rem",
  //           }}
  //         >
  //           {item.type === "file" ? (
  //             <Card

  //               sx={{ maxWidth: 300, borderRadius: 2, boxShadow: 3 }}>
  //               <CardMedia

  //                 image={amico} sx={{ height: 100, width: 150 }}
  //               />
  //             </Card>
  //           ) : (
  //             <Box>
  //               {item.clikkle && item.type === "folder" && (
  //                 <Folder style={{ fontSize: 100, color: "#488BF1" }} />
  //               )}
  //               {!item.clikkle && item.type === "folder" && (
  //                 <Folder style={{ fontSize: 100, color: "#FFCA28" }} />
  //               )}
  //             </Box>
  //           )}

  //           <Box
  //             width="100%"
  //             display="flex"
  //             justifyContent="space-between"
  //             alignItems={"center"}
  //           >
  //             {item.type === "file" && (() => {
  //               const { icon, color } = getFileIconAndColor(item.name.split(".").pop().toLowerCase());
  //               return React.cloneElement(icon, { style: { fontSize: 30, color } });
  //             })()}
  //             <Typography
  //               variant="body"
  //               fontFamily="sans-serif"
  //               fontWeight="500"
  //               lineHeight="2rem"
  //               whiteSpace={"nowrap"}
  //               textOverflow={"ellipsis"}
  //               overflow={"hidden"}
  //               sx={{
  //                 color: `${mode === "light" ? "rgba(0, 0, 0, 0.6)" : "#fff"} `,
  //               }}
  //             >
  //               {item.name}
  //             </Typography>
  //             <IconButton
  //               onClick={(e) => {
  //                 handleMoreVertMenuOpen(e, item)
  //                 setToggleSlideMenu(true);
  //               }}
  //               sx={{ color: "#A5A5A5", padding: "0" }}
  //             >
  //               <MoreHorizIcon style={{ fontSize: 30 }} />
  //             </IconButton>
  //           </Box>
  //         </Box>
  //       ))}
  //       <SlideUpMenu
  //         toggle={toggleSlideMenu}
  //         setToggle={setToggleSlideMenu}
  //         item={currentMenuClickedItem}
  //       />
  //     </Box>
  //   );
  // }

  if (items.length === 0) {
    return (
      <>
        {
          !isRecentView &&
          <Typography
            variant="body"
            fontFamily="sans-serif"
            fontWeight="700"
          >
            {title}
          </Typography>
        }


        <NoResourcesAvailable />
      </>
    )
  }
  return (
    <>

      {showTitle && title && items.length > 0 && !isRecentView &&
        <Typography
          variant="body"
          fontFamily="sans-serif"
          fontWeight="700"
        // marginTop={2}
        // sx={{
        //   marginTop:2
        // }}
        >
          {title}
        </Typography>}


      {/* <ItemMorevertMenu
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        currentMenuClickedItem={currentMenuClickedItem}
        item={currentMenuClickedItem}
        setClikkleItems={setClikkleItems}
        items={items}
      /> */}

      <Box
        display="grid"
        gap="1rem"
        // padding="0.5rem"
        paddingTop={isRecentView ? 0 : 2}
        width="100%"
        sx={{
          // gridTemplateColumns: `repeat(auto-fill, minmax(15rem, max-content))`,
          gridTemplateColumns: `repeat(auto-fill, minmax(15rem, 1fr))`,

          // justifyItems: "start",
        }}
      >

        {sortedItems.map((item, index) => (
          <Box
            key={index}
            padding="1rem"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent={"start"}
            maxWidth="270px"
            gap={"1rem"}
            sx={{
              backgroundColor: mode === "light" ? "white" : "#1E1E1E",
              border: `2px solid ${mode === "light" ? "#e5e7eb" : "transparent"}`,
              borderRadius: "0.5rem",
              ":hover": {
                backgroundColor: mode === "light" ? "#f7f7f7" : "#2E2E2E",
              },
            }}
          >
            <Box
              width="100%"
              display="flex"
              justifyContent="space-between"
              alignItems={"center"}

            >
              <Box
                display="flex"
                justifyContent="start"
                alignItems={"center"}
              >
                {item.clikkle && item.type === "folder" && (
                  <Folder style={{ fontSize: 30, color: "#488BF1" }} />
                )}
                {!item.clikkle && item.type === "folder" && (
                  <Folder style={{ fontSize: 30, color: "#FFCA28" }} />
                )}

                {item.type === "file" && (() => {
                  const { icon } = getFileIconAndColor({
                    type: item.type, // "file" or "folder"
                    extension: item.type === "file" ? item.name.split(".").pop().toLowerCase() : "",
                    isShortcut: item.isShortcut,
                    overrideColor: item.color,
                    fontSize: 25,
                    mode: mode,

                  });
                  ;
                  return icon;
                })()}
                <Typography
                  variant="body"
                  fontFamily="sans-serif"
                  fontWeight="500"
                  lineHeight="2rem"
                  whiteSpace={"nowrap"}
                  textOverflow={"ellipsis"}
                  overflow={"hidden"}
                  marginLeft={"5px"}
                  sx={{
                    color: `${mode === "light" ? "rgba(0, 0, 0, 0.6)" : "#fff"} `,
                  }}
                >
                  {/* {item.name} */}
                  {item.name?.length > 15 ? `${item.name.substring(0, 15)}...` : item.name}

                </Typography>
              </Box>
              <IconButton
                onClick={(e) => handleMoreVertMenuOpen(e, item)}
                sx={{ color: "#A5A5A5", padding: "0" }}
              >
                <MoreVert style={{ fontSize: 30 }} />
              </IconButton>
            </Box>

            <Card sx={{ maxWidth: 300, borderRadius: 2, boxShadow: mode !== 'light' && ["jpg", "jpeg", "png", "gif"].includes(item.name.split(".").pop()) ? 3 : 0 }}>
              {/* <CardMedia
              image={`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/access/67acad9e628d7c1ef4b39169?userId=675366531ab5835359e3e3d7`}
              alt="File Preview"
              sx={{ height: 150, width: 200 }}
            /> */}

              {["jpg", "jpeg", "png", "gif"].includes(item.name.split(".").pop()) ? (
                <CardMedia
                  onDoubleClick={() => handleDoubleClickFilePreview(item)}

                  image={`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/access/${item._id}?userId=${platformUser._id}`}
                  alt="File Preview"
                  sx={{ height: 150, width: 200 }}
                />
              ) : (
                (() => {
                  const { icon, color } = getFileIconAndColor({
                    extension: item.name.split(".").pop().toLowerCase(),
                    mode: mode,

                  });
                  return React.cloneElement(icon, { style: { fontSize: 140, color } });
                })()
              )}

            </Card>


          </Box>
        ))}
      </Box>
    </>
  );
};

export default TileFilesFolder;
